import React, { useEffect, useState } from 'react';
import { useTranslations } from 'hooks/useTranslations';
import { useGlobalProperty } from 'models/globalPropertyContext';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useCase } from '../../../hooks';
import { Elabels, getBreadcrumbsBasic } from 'pages/CaseManagementPage/CasesPage/helpers';
import { useQuery } from 'hooks/useQuery';
import { isPathEqualToRouteName } from 'utils/route';
import { ERouteLinks } from 'models/route';
import Breadcrumbs from 'components/atoms/Breadcrumbs';
import { Grid, Stack, Typography } from '@mui/material';
import { StyledPageTitle } from 'theme/styles';
import { Loader } from 'components/atoms/Loader';
import { StyledDetail } from 'pages/CaseManagementPage/CasesPage/styles';
import { getHtmlText } from 'components/organisms/HtmlSlate';
import { formatDate } from 'utils/date';

const NoteDetailsPage = () => {
  const { t } = useTranslations();
  const navigate = useNavigate();
  const {
    id = '',
    caseId = '',
    noteId = '',
  } = useParams<{ id: string; caseId: string; noteId: string }>();
  const query = useQuery();
  const type: string | null = query.get('type')?.trim() || null;
  const { pathname }: any = useLocation();
  const isFromLE = isPathEqualToRouteName(pathname, ERouteLinks.LegalEntityCaseNotePage);

  const { longDateFormat, getProperties } = useGlobalProperty();
  const { getNoteData, note } = useCase();
  const [isLoading, setIsLoading] = useState(true);
  const breadcrumbs = getBreadcrumbsBasic(isFromLE, type, t, false, id);

  useEffect(() => {
    getProperties();
  }, []);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getNoteData(noteId);
      setIsLoading(false);
    })();
  }, []);

  const editAction = (id: string) => {};
  const deleteAction = (id: string) => {};

  return (
    <>
      <Breadcrumbs
        items={[
          ...breadcrumbs,
          {
            label: t(Elabels.caseDetailsHeader),
            route: isFromLE
              ? `${ERouteLinks.LegalEntityCasesDetailsPage.replace(':caseId', caseId).replace(':id', id)}?type=${type}&expand=cases`
              : `${ERouteLinks.CasesDetailsPage.replace(':caseId', caseId)}`,
          },
          t(Elabels.caseNoteDetailsHeader),
        ]}
      />
      <Grid sx={{ display: 'flex', alignItems: 'center' }}>
        <StyledPageTitle variant="h4">{t(Elabels.caseNoteDetailsHeader)}</StyledPageTitle>
      </Grid>
      {isLoading && (
        <Grid size={{ xs: 12 }}>
          <Loader isLoading />
        </Grid>
      )}
      {!isLoading && note && (
        <Grid container sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
          <StyledDetail container size={{ xs: 12 }} sx={{ rowGap: 2 }}>
            <Grid size={{ xs: 12 }}>
              <Stack>
                <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                  {t(Elabels.notesName)}
                </Typography>
                <Typography variant="body2">{note.name}</Typography>
              </Stack>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Stack>
                <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                  {t(Elabels.description)}
                </Typography>
                <Typography variant="body2">{getHtmlText(note.description)}</Typography>
              </Stack>
            </Grid>

            <Grid size={{ xs: 12 }}>
              <Stack>
                <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
                  {t(Elabels.lastUpdate)}
                </Typography>
                <Typography variant="body2">{`${formatDate(note.lastModifiedDate, longDateFormat)} ${t('general.by.label')} ${note.lastAuthor}`}</Typography>
              </Stack>
            </Grid>
          </StyledDetail>
        </Grid>
      )}
    </>
  );
};

export default NoteDetailsPage;
